(function($, ajaxForm, History) {
    var History = window.History,
        $window = $(window);
        if (!History.enabled) {
            return false;
        }

        function stripDomain(url) {
    return url.replace(/^https?:\/\/[^/]+/, '');
}

    var rootUrl = History.getRootUrl();
    // Bind to StateChange Event
    History.Adapter.bind(window, 'statechange', function() { // Note: We are using statechange instead of popstate
        //console log des paramètres
        console.log('State change event triggered', arguments);
        var State = History.getState(),
        url = State.url,
        relativeUrl = url.replace(rootUrl, ''),
        target = State.data.target; // Note: We are using History.getState() instead of event.state
        //si pas de target on sort
        if (!target) return false;
        if (url.indexOf('#') != -1) {
            var tmp = url.split("#");
            url = tmp[0];
        }
        var currentUrl = stripDomain($('#' + target).data('form-url') || '');
        var compareUrl = stripDomain(url);

        if (currentUrl === compareUrl) {
            // console.log('URL is the same as current, no action taken:', url);
            return false;
        }
        url += (url.indexOf('?') == -1) ? "?ajax=" + target : "&ajax=" + target;
        
  
        //on charge le contenu

        $('#' + target).load(url, function(responseText) {
            var newContent = $(responseText).find('#' + target).html();
            $('#' + target).html(newContent);
            $("body").trigger("ajaxEnd", [$("#" + target)]);
            $("#" + target).data('form-url', compareUrl); // Mettre à jour l'URL actuelle

   
  

            //--images
            $('#' + target).find("a.lightbox").magnificPopup({
                type: 'image',
                removalDelay: 600,
                mainClass: 'mfp-fade',
                image: {
                    titleSrc: 'title'
                },
                callbacks: {
                    elementParse: function(item) {
                        item.alt = item.el.attr('title');
                        return item;
                    }
                }
            });

            magieObj.iniAjaxForm();
        });
      
        // $('html,body').animate({
        //     scrollTop: $('#' + target).offset().top
        // });
    });

    var magieObj = {
        checkURL: function(url, target) {
            if (url.indexOf('#') != -1) {
                var tmp = url.split("#");
                url = tmp[0];
            }
            url += (url.indexOf('?') == -1) ? "?ajax=" + target : "&ajax=" + target;
            return url;
        },

        iniAjaxForm: function() {
            var $_self = this;
     

            $('.ajaxForm').each(function(index, element) {
                if (!$(element).data('ajax-ready')) {
                    // console.log('Initializing ajaxForm for element:', element);
                    var urlform = ($(element).attr('action')) ? $_self.checkURL($(element).attr('action'), $(element).data('ajax-update')) : $_self.checkURL(document.location.pathname, $(element).data('ajax-update'));
                    // console.log('Form URL:', urlform);
                    $(element).ajaxForm({
                        target: '#' + $(element).data('ajax-update'),
                        // beforeSubmit: $_self.showRequest,
                        success: $_self.showResponse,
                        url: urlform
                    });

                    $(element).find("*[data-ajax-form-event]").each(function(index, ele) {
                        var fn = $(ele).attr('on' + $(ele).data('ajax-form-event'));
                        if (fn) $(ele).attr('on' + $(ele).data('ajax-form-event'), fn.replace(/(([a-z]+\.){1,2}submit\(\);?)/gi, ""));
                        $(ele).bind($(ele).data('ajax-form-event'), function(e) {
                            e.preventDefault();
                            // console.log('Form event triggered for element:', element);
                            // console.log($(element));
                            // if (!$(element).data('submitting')) {
                                // $(element).data('submitting', true);
                                $(element).submit();
                            // }
                        });
                    });
                    $(element).data('ajax-ready', true);
                }
            });
            $_self.iniAjaxLink();
        },

        showRequest: function(formData, jqForm, options) {
            // console.log('Form is about to be submitted:', jqForm);
            if (options.target) $('html,body').animate({
                scrollTop: $(options.target).offset().top
            });
        },
showResponse: function(responseText, statusText, xhr, $form) {
    // var $_self = this;
    // console.log('self', $_self);
    var target = $($form).data('ajax-update');
    var newContent = $(responseText).find('#' + target).html();
    $('#' + target).html(newContent);

    magieObj.iniAjaxForm();

    // --- Construction URL avec paramètres GET ---
    var method = $form.attr('method') || 'GET';
    var action = $form.attr('action') || document.location.pathname;

    // var urlform = magieObj.checkURL(action,target);
    var urlform = action;
    // console.log('Form action URL:', urlform);
    if (method.toUpperCase() === 'GET') {
        var formData = $form.serialize(); // ex : field1=value1&field2=value2
        if (formData) {
            urlform += (urlform.indexOf('?') === -1 ? '?' : '&') + formData;
        }
    }
    $('#' + target).data('form-url', urlform); // Stocker l'URL complète dans un attribut data

    // console.log('History.pushState with URL:', urlform);
    // --- Push state avec URL complète ---
    History.pushState({ target: target }, '', urlform);

    $($form).data('submitting', false);
},
        // showResponse: function(responseText, statusText, xhr, $form) {
        //     // console.log('Form submitted successfully:', $form);
        //     var $_self = this;
        //     var target = $($form).data('ajax-update');
        //     // $($form).removeData('submitting');
        //     // console.log('Form submitted successfully:', responseText);
        //     var newContent = $(responseText).find('#' + target).html();
        //     $('#' + target).html(newContent);

        //     magieObj.iniAjaxForm();
        //     var urlform = ($($form).attr('action')) ? $($form).attr('action') : document.location.pathname;
        //             console.log('History.pushState with URL:', urlform);
        //     History.pushState({
        //         target: target
        //     }, '', urlform);
      
        //     $($form).data('submitting', false); // Reset the submitting flag
        // },

        iniAjaxLink: function() {
            var $_self = this;
            $('.ajaxLink').each(function(index, element) {
                if ($(element).data('ajax-update')) {
                    $(element).bind("click", function(e) {
                        e.preventDefault();
                        // console.log('Ajax link clicked:', element);
                        History.pushState({
                            target: $(element).data('ajax-update')
                        }, $(element).attr('title'), $(element).attr('href'));
                    });
                }
            });
        }
    }

    $(document).ready(function() {
        magieObj.iniAjaxForm();
        // console.log('AjaxMagie is ready');
    });

})(jQuery, jQuery.fn.ajaxForm, window.History);